module.exports = __webpack_public_path__ + "img/upilist.2bdaeab2.jpg";